/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import Firebase from 'firebase/app';
import * as FirebaseUI from 'firebaseui';


const filterSearchParams = (search) =>
{
  const searchParams = new URLSearchParams(window.location.search);

  searchParams.delete('current');
  searchParams.delete('target');

  return searchParams.toString();
}


const resolveAnonymousMergeConflict = (rpc, error) =>
{
  const anonymous = Firebase.auth().currentUser;

  const getToken = () =>
  {
    return anonymous.getIdToken(true);
  }

  const deleteRpcCallback = (token) =>
  {
    return rpc.deleteUser(token);
  };

  const deleteFirebaseCallback = () =>
  {
    return anonymous.delete();
  }

  const signInCallback = () =>
  {
    return Firebase.auth().signInWithCredential(error.credential);
  }

  const redirectLocationCallback = () =>
  {
    const { host, search, protocol} = window.location;

    window.location.assign(`${protocol}//${host}${filterSearchParams(search)}`);
  };

  // We need to deleteRpc & deleteFirebase before we sign in with the correct credentials (anonymous user will became obsolte).
  return getToken().then(deleteRpcCallback).then(deleteFirebaseCallback).then(signInCallback).then(redirectLocationCallback);
}


const getSignInFailureCallback = (rpc) =>
{
  return (error) =>
  {
    if (error.code === 'firebaseui/anonymous-upgrade-merge-conflict')
    {
      resolveAnonymousMergeConflict(rpc, error);
    }

    console.log('Firebase sign-in error!', error);
  };
}


const getBasicConfig = (rpc) =>
{
  const { host, search, protocol} = window.location;

  return (
  {
    // Default sign-in through popup - though mobile may prefer redirect.
    signInFlow: 'popup',

    // Automatically upgrade anonymous users.
    autoUpgradeAnonymousUsers: true,

    // Popup can be blocked by browser; fallback to full page redirect.
    signInSuccessUrl: `${protocol}//${host}${filterSearchParams(search)}`,

    callbacks:
    {
      signInFailure: getSignInFailureCallback(rpc),
    },

    signInOptions: [],

    tosUrl: `${protocol}//${host}/terms${search}`,
    privacyPolicyUrl: `${protocol}//${host}/privacy${search}`,
  });
}


const googleProvider =
{
  provider: Firebase.auth.GoogleAuthProvider.PROVIDER_ID,
  customParameters:
  {
    prompt: 'select_account',
  }
};


const facebookProvider =
{
  provider: Firebase.auth.FacebookAuthProvider.PROVIDER_ID,
  scopes:
  [
    'email',
  ],
  customParameters:
  {
    display: 'popup',
  }
};


const anonymousProvider =
{
  provider: FirebaseUI.auth.AnonymousAuthProvider.PROVIDER_ID,
  iconUrl: '/favicon-dark.ico',
  //buttonColor: '#2F2F2F',
  //fullLabel: 'Play as Guest',
};


export const getAnonymousConfig = (rpc) =>
{
  let config = getBasicConfig(rpc);

  config.signInOptions.push(anonymousProvider);

  return config;
};


export const getDefaultConfig = (rpc) =>
{
  let config = getBasicConfig(rpc);

  config.signInOptions.push(googleProvider);
  config.signInOptions.push(facebookProvider);

  return config;
}


export const getFullConfig = (rpc) =>
{
  let config = getBasicConfig(rpc);

  config.signInOptions.push(googleProvider);
  config.signInOptions.push(facebookProvider);
  config.signInOptions.push(anonymousProvider);

  return config;
}


export const getInstance = () =>
{
  const instance = FirebaseUI.auth.AuthUI.getInstance();

  return instance ? instance : new FirebaseUI.auth.AuthUI(Firebase.auth());
}
